import { exportFileFormat } from '../../../utils/ExportFileUtils'
import interceptedAxios from '../../../utils/interceptedAxios'

export async function exportFirmwareUpgradeStatusGrid (
  onSuccess: (exportFile: any) => any,
  onFailure: (errorMessage: string) => any
): Promise<void> {
  const url = '/asset-config-service/api/v1/udp/firmwareCampaign/download'
  interceptedAxios
    .get(url, { responseType: 'blob' })
    .then((response) => {
      exportFileFormat(response, 'FirmwareUpgradeStatus_')
      onSuccess(response)
    })
    .catch((error) => {
      onFailure(error)
    })
}
